export function sequenceById(state, id){
    for(let seq of state.sequences){
        if (seq.seqId==id){
            return seq;
        }
    }
    return null;
}